module.exports = "<div class=\"loader-con\" *ngIf=\"show\">\r\n\t<div class=\"loader\"></div>\r\n</div>\r\n"